export function padLinear([x0, x1], k) {
  const dx = (x1 - x0) * k / 2;
  return [x0 - dx, x1 + dx];
}

export function getNestedAttr (d,attr){
  return attr.split('.').reduce((node,part)=>{
    if(Array.isArray(node)) return node.find((item)=>item.name===part)
    else return node && node[part]? node[part] : {}
  },d)
}

export function getGeneralCharacteristicField (d,fieldName){
  // return 'base_pop_field'
  let field = d.subject.general_characteristics.find((f)=>f.view.name === fieldName)
  let vals = field && field.value
  // let vals = d.subject.generationParas.exm
  if(vals && vals.length === 1) return vals[0]
  else return vals
}
export function getOtherSubjectFields (d,fieldName){
  // return ['other_field']
  let candidate = d.subject[fieldName] || d.trialMeta[fieldName]
  if(candidate && candidate.length>0) return candidate.map((f)=>f.name)
  else return null
}
// export function getAvailableCohortFields (d,fieldName){
//   return d.cohort.basePopulations.fields.map((f)=>f.name)
// }

export function createArray(len, itm) {
  var arr1 = [itm],
      arr2 = [];
  while (len > 0) {
      if (len & 1) arr2 = arr2.concat(arr1);
      arr1 = arr1.concat(arr1);
      len >>>= 1;
  }
  return arr2;
}

export function timeToString(val) {
  return Math.round(val*1000)+'ms'
}

import numeral from 'numeral'
export function formatValue(val) {
  let nm = numeral(val)
  if(val===0) return 0
  else if(Math.abs(val)>999) return nm.format('0.0a')
  else if (Math.abs(val)<0.1) return nm.format('0.00e+0')
  else return nm.format('0.00')
}